import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  homeClicked$ = new Subject<void>();
  bookmarkClicked$ = new Subject<void>();

  notifyBookmarkClicked() {
    this.bookmarkClicked$.next();
  }

  notifyHomeClicked() {
    this.homeClicked$.next();
  }


}
